import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import { useSidebar } from '../context/SidebarContext';
import { useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import useIsMobile from '../utils/useIsMobile';
import { useAuth } from '../context/AuthContext';
import AvvisoSupporto from './supporto/AvvisoSupporto';
import AvvisoCalendario from './calendario/AvvisoCalendario';

// Cornice dello staff. Desktop: sidebar fissa (comprimibile). Telefono: barra in alto con
// pulsante menu e sidebar a scomparsa sopra la pagina, che si chiude cambiando pagina.
export default function Layout({ children }) {
  const { collapsed } = useSidebar();
  const location = useLocation();
  const mobile = useIsMobile();
  const { user } = useAuth();
  // avvisi a schermo in basso a destra, uno sopra l'altro
  const avvisi = (
    <div style={s.avvisi}>
      <AvvisoCalendario attivo={user?.ruolo === 'ROOT' || !!user?.permessi?.calendario?.edit} utente={user?.id}/>
      <AvvisoSupporto attivo={user?.ruolo === 'ROOT' || !!user?.permessi?.ticket?.view}/>
    </div>
  );
  const [aperto, setAperto] = useState(false);
  useEffect(() => { setAperto(false); }, [location.pathname]);
  useEffect(() => { if (!mobile) setAperto(false); }, [mobile]);

  if (mobile) return (
    <div style={{ minHeight:'100vh', background:'var(--bg)' }}>
      <header className="barra-mobile" style={s.bar}>
        <button style={s.menuBtn} onClick={() => setAperto(true)} aria-label="Apri il menu"><Menu size={22} color="var(--text)"/></button>
        <span style={s.brand}>B-CHEERS ASD</span>
      </header>
      {aperto && <>
        <div style={s.velo} onClick={() => setAperto(false)} aria-hidden="true"/>
        <Sidebar mobile/>
        <button style={s.chiudi} onClick={() => setAperto(false)} aria-label="Chiudi il menu"><X size={20} color="#fff"/></button>
      </>}
      <main style={{ padding:'16px', color:'var(--text)', overflowX:'hidden' }}>
        <div key={location.pathname} className="pagina-entra">{children}</div>
      </main>
      {avvisi}
    </div>
  );

  return (
    <div style={{ display:'flex', minHeight:'100vh', background:'var(--bg)' }}>
      <Sidebar/>
      <main style={{
        marginLeft: collapsed ? '84px' : '244px',
        flex: 1,
        padding: '32px',
        minHeight: '100vh',
        minWidth: 0,
        color: 'var(--text)',
        transition: 'margin-left 0.2s ease',
      }}>
        <div key={location.pathname} className="pagina-entra">{children}</div>
      </main>
      {avvisi}
    </div>
  );
}

const s = {
  avvisi:  { position:'fixed', right:'16px', bottom:'16px', zIndex:2500, display:'flex', flexDirection:'column', gap:'10px', alignItems:'flex-end', pointerEvents:'none' },
  bar:     { position:'sticky', top:0, zIndex:900, display:'flex', alignItems:'center', gap:'10px', height:'56px', padding:'0 12px', background:'var(--bg)', borderBottom:'1px solid var(--border)' },
  menuBtn: { width:'44px', height:'44px', display:'flex', alignItems:'center', justifyContent:'center', background:'transparent', border:'none', borderRadius:'10px', cursor:'pointer', padding:0 },
  brand:   { fontFamily:"'Barlow Condensed'", fontSize:'20px', fontWeight:800, color:'#F4600C', letterSpacing:'2px' },
  velo:    { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:1000 },
  chiudi:  { position:'fixed', top:'10px', left:'284px', zIndex:1002, width:'44px', height:'44px', borderRadius:'50%', border:'none', background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', padding:0 },
};
